import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GuestLayoutComponent } from './guest-layout.component';
import { TranslocoModule } from '@ngneat/transloco';
import { RouterModule } from '@angular/router';
import { LanguageSwitchModule } from 'app/common/components/language-switch/language-switch.module';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';

@NgModule({
  declarations: [
    GuestLayoutComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslocoModule,
    LanguageSwitchModule,
    FontAwesomeModule
  ],
  exports: [
    // RouterModule,
    GuestLayoutComponent
  ]
})
export class GuestLayoutModule {
   constructor(library: FaIconLibrary){
    library.addIconPacks(fas);
  }
}
